
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { IoHomeSharp } from "react-icons/io5";
import { MdEditDocument } from "react-icons/md";

import Commonheader from "../CommonUtils/Commonheader";
import { MenuItem } from "./MenuItems";
import BasicDetails from "../NocComponents/BasicDetails";
import ServiceCards from "../NocComponents/ServiceCards";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";


export function MenuBar({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const UserGroupcode = sessionStorage?.getItem("Group_Code");
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  const path = location.pathname.replace("/", "").toLowerCase() || "home";
  const activeMenu = path;

  const [serviceKey, setServiceKey] = useState(0);
  const [basicDetailsKey, setBasicDetailsKey] = useState(0);

  const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];

  const filtered = menuData.filter(
    (item) => item.service_name?.toLowerCase() !== "home"
  );

  const sorted = [...filtered].sort((a, b) => a.priority - b.priority);

  const parents = sorted.filter((item) => item.parent_id === null);
  const kids = sorted.filter((item) => item.parent_id !== null);

  const hasHierarchy = parents.length > 0 && kids.length > 0;

  useEffect(() => {
    const onResize = () => setSidebarOpen(window.innerWidth > 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);



  const menuItems = hasHierarchy
    ? parents.map((parent) => ({
      item: parent,
      kids: kids
        .filter((c) => c.parent_id === parent.service_id)
        .sort((a, b) => a.priority - b.priority),
    }))
    : sorted.map((item) => ({ item, kids: [] }));



  const [condition, setCondition] = useState([]);

  function CheckServicesCondition() {
    CommonAxiosGet(`${config.url.FAC_URL}getCheckServiCount`).then((res) => {
      setCondition(res?.data?.scode === "01" ? res.data.count || [] : []);
    });
  }

  useEffect(() => {
    if (UserGroupcode === "10") {
      CheckServicesCondition();

    }
  }, []);
  // ✅ Check all completed
  const isServicesAllowed = () => {
    const c = condition[0];
    if (!c) return false;
    return Object.values(c).every((v) => v === "completed");
  };

  const labelMap = {
    inst_dtls: "Institute Details",
    course_details: "Course Intake Details",
    infra_dtls: "Infrastructure",
    staff_dtls: "Staff Details",
  };

  const getIncompleteList = () =>
    Object.entries(condition[0] || {})
      .filter(([, v]) => v !== "completed")
      .map(([k]) => labelMap[k] || k);

  const handleSelect = (item) => {
    const target = item.target;
    if (target.toLowerCase() === "services" && !isServicesAllowed()) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Institute Profile",
        html: `Complete these sections first:<br/><br/>
        ${getIncompleteList().map((i) => `❌ ${i}`).join("<br/>")}`,
        confirmButtonColor: "#0f6fbe",
      });


      return;
    }

    if (target.toLowerCase() === "services") setServiceKey((prev) => prev + 1);
    if (target.toLowerCase() === "basicdetails") setBasicDetailsKey((prev) => prev + 1);

    navigate(`/${target}`);
  };
  return (
    <>
      <Commonheader />

      <div className="dashboard-container vh-100">
        <div className="main-area">
          <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
            <Button
              className="toggle-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? (
                <img
                  src="../images/toggle1.svg"
                  className="img-fluid toggle1"
                  alt="toggle1"
                />
              ) : (
                <img
                  src="../images/toggle2.svg"
                  className="img-fluid toggle2"
                  alt="toggle2"
                />
              )}
            </Button>

            <ul className="sidebar-menu">
            <li
  className={`single-menu home-menu ${
    activeMenu === "home" ? "active" : ""
  }`}
  role="menuitem"
  tabIndex={0}
  onClick={() => navigate("/home")}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      navigate("/home");
    }
  }}
>
                <IoHomeSharp size={16} className="me-2" />
                {sidebarOpen && <span className="child-itemnew">Home</span>}
              </li>

              {menuItems?.map(({ item, kids }) => (
                <MenuItem
                  key={item.service_id}
                  item={item}
                  kids={kids}
                  activeMenu={activeMenu}
                  onSelect={handleSelect}
                  sidebarOpen={sidebarOpen}
                  defaultIcon={MdEditDocument}
                />
              ))}
            </ul>

            <div className="sidebar-footer">
              <p className="mb-0">
                Powered By{" "}
                <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                  <img
                    src="../images/dashboard-footer.png"
                    alt=""
                    className="img-fluid"
                  />
                </a>
              </p>
            </div>
          </aside>

          <main className="content-box">
            <div className="inner-content">
              {path === "basicdetails" ? (
                <BasicDetails key={basicDetailsKey} />
              ) : path === "services" ? (
                <ServiceCards key={serviceKey} />
              ) : (
                children
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default MenuBar;
